import { StepConfig } from '../../dynamicForm/types/fieldTypes';

export const contactStep: StepConfig = {
  title: 'Contact',
  description: 'How should buyers contact you?',
  sections: [
    {
      title: 'Contact Preferences',
      fields: [
        {
          name: 'telephoneNumber',
          type: 'text',
          label: 'Phone number for this listing (optional)',
          required: false,
          layout: { span: 24 },
          validations: [
            { type: 'minLength', message: 'Phone number must be at least 7 characters', value: 7 },
            { type: 'maxLength', message: 'Phone number cannot exceed 20 characters', value: 20 },
          ],
          customProps: {
            placeholder: 'Leave blank to use profile phone',
            addonBefore: '+355',
          },
        },
        {
          name: 'displayPhoneNumber',
          type: 'select',
          label: 'Display phone number in ad?',
          required: true,
          layout: { span: 24 },
          options: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
          ],
          customProps: { placeholder: 'Select option' },
        },
        {
          name: 'showWhatsApp',
          type: 'select',
          label: 'Show WhatsApp button on listing?',
          required: true,
          layout: { span: 24 },
          options: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
          ],
          customProps: {
            placeholder: 'Select option',
            helpText:
              'Buyers will be able to contact you directly via WhatsApp using your phone number.',
          },
        },
      ],
    },
  ],
  footer: {
    buttons: [
      {
        label: 'Back',
        action: 'back',
        position: 'left',
        variant: 'secondary',
        icon: 'bi-arrow-left',
      },
      {
        label: 'Publish Listing',
        action: 'submit',
        position: 'right',
        variant: 'primary',
        icon: 'bi-check',
      },
    ],
  },
};
